"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/slicedToArray.js"));
require("core-js/modules/es.number.constructor.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'WlInputPrice',
  props: {
    /* v-model */
    value: {
      type: [Number, String],
      default: 0
    }
  },
  data: function data() {
    return {
      /* input v-model */
      priceValue: 0,
      /* value 的字符串显示 */
      // priceValueString: 0,
      /* 焦点状态 */
      focus: false
    };
  },
  computed: {
    options: function options() {
      return Object.assign({}, this.$attrs, this.$props);
    },
    priceValueString: function priceValueString() {
      /* 格式化 增加千分位字符 */
      var a = String(this.priceValue);
      var _a$split = a.split('.'),
        _a$split2 = (0, _slicedToArray2.default)(_a$split, 2),
        b = _a$split2[0],
        c = _a$split2[1];
      var str = "".concat(Number(b).toLocaleString());
      if (c) str += ".".concat(c);
      return str;
    }
  },
  watch: {
    value: {
      handler: function handler(nv) {
        // eslint-disable-next-line eqeqeq
        this.priceValue != nv && !this.focus && (this.priceValue = nv);
      },
      deep: true,
      immediate: true
    },
    priceValue: {
      handler: function handler(nv, ov) {
        this.$emit('change', nv, ov);
        if (!this.focus) this.$emit('input', this.priceValue);
      },
      deep: true,
      immediate: true
    },
    focus: {
      handler: function handler(nv) {
        var _this = this;
        if (nv) {
          this.$nextTick(function () {
            var _this$$refs;
            (_this$$refs = _this.$refs) === null || _this$$refs === void 0 || (_this$$refs = _this$$refs.input) === null || _this$$refs === void 0 || (_this$$refs = _this$$refs.$refs) === null || _this$$refs === void 0 || _this$$refs.input.focus();
          });
        }
      }
    }
  },
  methods: {
    /** 设置焦点状态
     * @param { Boolean } status 设置焦点的状态
     * @return { void }
     */
    setFocus: function setFocus(status) {
      var _this2 = this;
      this.focus = status;
      this.$nextTick(function () {
        if (status) {
          //
        } else {
          /* 确保是数字 */
          _this2.priceValue = parseFloat(_this2.priceValue);
          _this2.$emit('input', _this2.priceValue);
        }
      });
    }
  }
};